import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Route to Inbox
 */

export default function RouteToInboxIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M2.54309 2.79693C2.62334 2.61637 2.80241 2.5 3 2.5H12.5C12.6816 2.5 12.8489 2.59845 12.9371 2.75718L15.4371 7.25718C15.4783 7.33146 15.5 7.41503 15.5 7.5V13C15.5 13.2761 15.2761 13.5 15 13.5H1C0.723858 13.5 0.5 13.2761 0.5 13V7.5C0.5 7.43004 0.514681 7.36086 0.543094 7.29693L2.54309 2.79693ZM3.32494 3.5L1.76938 7H5.5C5.68158 7 5.84889 7.09845 5.93708 7.25718C6.12667 7.59844 6.39154 7.97193 6.70512 8.28551C7.02137 8.60176 7.36286 8.83298 7.7031 8.93268C8.02623 9.02736 8.36912 9.01114 8.74299 8.79621C9.1333 8.57184 9.58793 8.11217 10.0629 7.25718C10.1511 7.09845 10.3184 7 10.5 7H14.1502L12.2058 3.5H3.32494ZM14.5 8H10.7885C10.3057 8.80296 9.78926 9.34821 9.24138 9.66317C8.62046 10.0201 7.9946 10.0601 7.4219 9.89232C6.86631 9.72952 6.38488 9.37949 5.99801 8.99262C5.68872 8.68333 5.42425 8.33499 5.21474 8H1.5V12.5H14.5V8Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
